import React, {Component} from 'react';
import PropTypes from 'prop-types';
import './VacationPopup.scss';
import VacationForm from './VacationForm/VacationForm';
import {Popup} from '../index';

class VacationPopup extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isOpen: this.props.isOpen || false
        };

        this.close = this.close.bind(this);
    }

    componentWillReceiveProps(nextProps) {

        if (nextProps.isOpen !== this.state.isOpen) {
            this.setState({ isOpen: nextProps.isOpen });
        }
    }

    close(e, data, fromSubmit = false) {
        if (e && e.preventDefault) {
            e.preventDefault();
        }

        this.setState({
            isOpen: false
        }, () => this.props.closePopup(e, data, fromSubmit));
    }

    render() {
        if (!Popup) {
            return null;
        }

        const {
            dateVal,
            whyVacation,
            buyerMessage,
            allowContact,
            userId
        } = this.props;

        const close = this.close;

        return (
            <Popup isOpen={this.state.isOpen}
                closePopup={(e) => this.close(e, null, false)}
                parent={this}
                title={i18n.t('out_of_office.popup.title')}
                name="out-of-office-popup"
                darken
                layout="base"
                noScroll={true}>
                <VacationForm dateVal={dateVal}
                    whyVacation={whyVacation}
                    allowContact={allowContact}
                    buyerMessage={buyerMessage}
                    close={close}
                    userId={userId}/>
            </Popup>
        );
    }
}

VacationPopup.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    userId: PropTypes.number.isRequired,
    whyVacation: PropTypes.string,
    buyerMessage: PropTypes.string,
    allowContact: PropTypes.bool,
    closePopup: PropTypes.func.isRequired
};

VacationPopup.defaultProps = {
    isOpen: false,
    userId: 0,
    whyVacation: '',
    buyerMessage: '',
    allowContact: false,
    closePopup: () => null
};

export default VacationPopup;


// WEBPACK FOOTER //
// ./src/VacationPopup/VacationPopup.js